import React from 'react'
import healthcare1 from '../images/aslogic.png';
import healthcare2 from '../images/aslogic2.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function AstraLogic() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">AstraLogic</span> – AI Powered ERP Software
                    </div>



                </div>
            </section>

            <section className="container my-5">
                {/* Section 1: Project Overview */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="Remente App Overview"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">AstraLogic</span> – AI Powered ERP Software
                        </h1>

                        <p className="mb-3 ps-1">
                            AstraLogic is a next-generation AI-powered ERP system designed to unify business operations, automate workflows,
                            and deliver real-time intelligence across all departments. It helps organizations streamline processes,
                            reduce manual workloads, and operate with higher efficiency and precision.
                        </p>

                        <p className="mb-3 ps-1">
                            From smart inventory and finance automation to HR management, CRM, and AI-driven insights, AstraLogic enables businesses
                            to make faster decisions, enhance productivity, and scale operations with a fully integrated digital ecosystem.
                        </p>

                        <p className="mb-3 ps-1 fw-bold">
                            <span className="highlight-orange">Proven Impact:</span> Businesses using AstraLogic’s ERP modules have experienced
                            <span className="highlight-orange"> a 35–50% reduction in operational costs</span>, improved workflow accuracy, and
                            <span className="highlight-orange"> up to 2.5× ROI within the first 6 months</span>. Centralized automation, real-time data visibility,
                            and streamlined department coordination significantly boost productivity and long-term scalability.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Section 2: Summary & Team Info */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> AstraLogic
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
                        <p className="mb-3 ps-3">USA</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Technology & Purpose</h4>
                        <p className="mb-3 ps-3">
                            AI Automation Engine, ERP Workflow Orchestration, Multi-Module Integration, React, Node.js, Firebase, REST APIs,
                            Machine Learning Models, Real-Time Analytics Dashboard
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Domain</h4>
                        <p className="mb-3 ps-3">AI Powered ERP System</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Team Involvement</h4>
                        <p className="mb-3 ps-3">
                            UI/UX Designer, 2 Frontend Engineers, Backend Architect, Automation Engineer, AI Developer, QA Engineer
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Duration</h4>
                        <p className="mb-4 ps-3">6 Months</p>

                        <p className="mb-4 ps-3">
                            AstraLogic is a powerful AI-driven ERP platform built to streamline and automate core business operations across finance,
                            HR, inventory, sales, and workflow management. With intelligent automation, predictive analytics, and a fully integrated
                            module ecosystem, AstraLogic helps organizations improve accuracy, reduce operational costs, and make real-time data-informed decisions.
                            Its AI-enhanced process automation, smart dashboards, and seamless multi-department connectivity enable businesses to scale faster
                            and operate with maximum efficiency.
                        </p>




                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="Remente UI"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Section 3: Process & Key Features */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="Mental Wellness Features"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Process</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            We developed AstraLogic with an AI-first ERP architecture focused on automation, modular scalability, and
                            real-time operational intelligence. The platform integrates multiple business modules — including finance, HR,
                            inventory, sales, and workflow management — into a unified system powered by machine learning models and
                            automated decision engines. Our backend ensures high availability, secure data processing, and seamless
                            synchronization across all departments.
                        </p>

                        <p className="mb-3 ps-1">
                            The UI/UX was crafted to simplify complex ERP operations and make AI-driven automation accessible to businesses of
                            every size. A clean, intuitive, and role-based interface allows teams to manage resources, track performance,
                            automate tasks, and collaborate efficiently — without requiring specialized technical knowledge.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
                        <ul className="ps-3 mb-4">
                            <li className="mb-1">AI-powered workflow automation across all ERP modules</li>
                            <li className="mb-1">Smart inventory management with demand forecasting</li>
                            <li className="mb-1">Automated finance & billing system with real-time reconciliation</li>
                            <li className="mb-1">HR automation tools: attendance, payroll, onboarding workflows</li>
                            <li className="mb-1">Real-time analytics dashboard with predictive insights</li>
                            <li className="mb-1">Centralized multi-department data syncing for seamless operations</li>
                        </ul>



                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>
                    </div>
                </div>

                <OurPartner />
            </section>

        </>
    )
}

export default AstraLogic